// @flow

import Game from '@/lib/game';

export default class {
  static isSatisfied(game: Game): boolean {
    const { cherryAdultTreesCount } = game.stats;
    return cherryAdultTreesCount >= 5 && game.virtualTime.season === 'spring';
  }

  static makeAchievement() {
    return {
      uid: 'cherry_forest',
      title: '花見会場',
      body: '人々は満開の桜の花の下で花見を楽しんでいるようです。',
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/achievement_conditions/cherry_forest.js